import type { InboxItem } from '@store/reducers/inbox'

export interface MonthGroup {
  // the month name, with the year when it is not this year; '' for the
  // month `now` is in, which the page titles Earlier
  label: string
  items: InboxItem[]
}

const monthKey = (ts: number): string => {
  const date = new Date(ts)

  return `${date.getFullYear()}-${date.getMonth()}`
}

const monthLabel = (ts: number, now: number): string => {
  const date = new Date(ts)
  const sameYear = date.getFullYear() === new Date(now).getFullYear()

  return date.toLocaleDateString('en-US', {
    month: 'long',
    ...(sameYear ? {} : { year: 'numeric' }),
  })
}

// Rows in the order given, cut into months: the current month first, every
// older month as a section of its own
export const groupByMonth = (items: InboxItem[], now: number): MonthGroup[] =>
  items.reduce<MonthGroup[]>((groups, item) => {
    const key = monthKey(item.createdAt)
    const label = key === monthKey(now) ? '' : monthLabel(item.createdAt, now)
    const last = groups[groups.length - 1]

    if (
      last &&
      last.label === label &&
      monthKey(last.items[0].createdAt) === key
    ) {
      return [...groups.slice(0, -1), { ...last, items: [...last.items, item] }]
    }

    return [...groups, { label, items: [item] }]
  }, [])
